export type PossibleTypesResultData = {
  possibleTypes: {
    RecipeIngredient: ["ReferenceRecipeIngredient", "UserRecipeIngredient"];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    RecipeIngredient: ["ReferenceRecipeIngredient", "UserRecipeIngredient"],
  },
};
export default result;
